export default __webpack_public_path__ + "static/media/mail.389dc5d9.png";